// 知识->个人
export default {
  path: "/doc",
  name: "doc",
  component: () => import("@/CommonDP/pages/mainMg/doc/doc"),
  meta: {
    routeName: "个人",
    icon: require("@/CommonDP/assets/settings/doc1.png"),
  },
  children: [
    {
      path: "/persondoc",
      name: "persondoc",
      component: () => import("@/CommonDP/pages/mainMg/doc/personDoc.vue"),
      meta: {
        routeName: "个人文档",
        prouteName: "个人文档",
        pname: "个人",
        icon1: require("@/CommonDP/assets/doc/个人文档.png"),
        icon2: require("@/CommonDP/assets/doc/个人文档.png"),
      },
      children: [
        {
          path: "/mydoc",
          name: "mydoc",
          component: () => import("@/CommonDP/pages/mainMg/doc/myDoc/myDoc"),
          meta: {
            routeName: "我的文档",
            prouteName: "个人文档/我的文档",
            ppname: "个人",
          },
        },
        {
          path: "/myshare",
          name: "myshare",
          component: () => import("@/CommonDP/pages/mainMg/doc/myShare/myShare"),
          meta: {
            routeName: "我的分享",
            prouteName: "个人文档/我的分享",
            ppname: "个人",
          },
        },
        {
          path: "/mycollection",
          name: "mycollection",
          component: () => import("@/CommonDP/pages/mainMg/doc/myFavorite/myFavorite"),
          meta: {
            routeName: "我的收藏",
            prouteName: "个人文档/我的收藏",
            ppname: "个人",
          },
        },
        {
          path: "/myrecycle",
          name: "myrecycle",
          component: () => import("@/CommonDP/pages/components/recycle"),
          props: { type: 2 },
          meta: {
            routeName: "回收站",
            prouteName: "个人文档/回收站",
            ppname: "个人",
          },
        },
      ],
    },
    {
      path: "/enterprisedoc",
      name: "enterprisedoc",
      component: () => import("@/CommonDP/pages/mainMg/doc/enterpriseDoc.vue"),
      meta: {
        routeName: "企业文档",
        prouteName: "企业文档",
        pname: "个人",
        icon1: require("@/CommonDP/assets/doc/企业文档.png"),
        icon2: require("@/CommonDP/assets/doc/企业文档.png"),
      },
      children: [
        {
          path: "/sharinformation",
          name: "sharinformation",
          component: () => import("@/CommonDP/pages/mainMg/doc/sharinFormation/sharinFormation"),
          meta: {
            routeName: "分享资料",
            prouteName: "企业文档/分享资料",
            ppname: "个人",
          },
        },
        {
          path: "/Publicinformation",
          name: "publicinformation",
          component: () => import("@/CommonDP/pages/mainMg/doc/publicinFormation/publicinFormation"),
          meta: {
            routeName: "公共资料",
            prouteName: "企业文档/公共资料",
            ppname: "个人",
          },
        },
        {
          path: "/entprecycle",
          name: "entprecycle",
          component: () => import("@/CommonDP/pages/components/recycle"),
          props: { type: 3 },
          meta: {
            routeName: "回收站",
            prouteName: "企业文档/回收站",
            ppname: "个人",
          },
        },
      ],
    },
    {
      path: "/enterpriseDeptDoc",
      name: "enterpriseDeptDoc",
      component: () => import("@/CommonDP/pages/mainMg/doc/enterpriseDeptDoc.vue"),
      meta: {
        routeName: "部门文档",
        prouteName: "部门文档",
        pname: "个人",
        icon1: require("@/CommonDP/assets/doc/部门文档.png"),
        icon2: require("@/CommonDP/assets/doc/部门文档.png"),
      },
      children: [],
    },
  ],
};
